import { render, staticRenderFns } from "./ServiceQuotationItem.vue?vue&type=template&id=be76d3b2&scoped=true&"
import script from "./ServiceQuotationItem.vue?vue&type=script&lang=js&"
export * from "./ServiceQuotationItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceQuotationItem.vue?vue&type=style&index=0&id=be76d3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76d3b2",
  null
  
)

export default component.exports